export default {
  name: "fan"
};